module.exports = __webpack_public_path__ + "static/media/DEEP-LEARNING.307a94c5.svg";